import React, {Component} from "react"
import styles from "./Footer.module.css"
import avedamaineLogo from "../Header/parts/img/logo-avedamaine-black.png"

const campuses = [
    {
        id: 1,
        region_id: 1,
        name: "Aveda Institute Maine",
        code: "Aveda Institute Maine",
        address: "43 Bridge St, Augusta, ME 04330",
        state: "",
        phone: "207-621-9941",
        school_code: "",
        region: {
            id: 1,
            state: "Maine",
            region: "Maine"
        }
    }
]

const social = [
    {
        id: 1,
        name: "Facebook",
        link: "https://www.facebook.com/avedainstitutemaine/",
        icon: "fa fa-facebook"
    },
    {
        id: 2,
        name: "Instagram",
        link: "https://www.instagram.com/avedamaine/",
        icon: "fa fa-instagram"
    },
    {
        id: 3,
        name: "Twitter",
        link: "https://twitter.com/Aveda_Maine",
        icon: "fa fa-twitter"
    }
]

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div>
                        <div>
                            <a
                                href="https://www.capilo.com/"
                                target="_blank"
                                rel="noopener noreferrer">
                                <img
                                    src={avedamaineLogo}
                                    alt="avedamaine-logo"
                                    className={styles.logo}
                                />
                            </a>
                        </div>
                        <div className={styles.social}>
                            {social.map(({id, link, icon}) => (
                                <a
                                    href={link}
                                    className={icon}
                                    key={id}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {""}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.campuses}>
                        <h5>
                            <strong>CAMPUS</strong>
                        </h5>
                        {campuses.map(({code, address, phone, id}) => (
                            <div className={styles.campusContainer} key={id}>
                                <div className={styles.code}>
                                    <strong>{code}</strong>
                                </div>
                                <div className={styles.address}>{address}</div>
                                <div className={styles.phone}>
                                    <strong>Ph:</strong> {phone}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </footer>
        )
    }
}
